import React, { useEffect, useState } from "react";
import API from "../services/api";

function RejectedAgentsPage() {
    const [agents, setAgents] = useState([]);
    const [selectedAgent, setSelectedAgent] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await API.get("/logs/rejected");
            setAgents(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    // 🔥 FIXED: Logic to clean path and point to the correct server domain
    const getPdfUrl = (agent) => {
        if (!agent.pdf) return null;
        
        // Remove leading slashes to prevent "double slash" errors in the URL
        const cleanPath = agent.pdf.replace(/^\/+/, ""); 
        
        // Using the production domain as we did in the FormPage fix
        return `https://vgmconsult.net/api/${cleanPath}`;
        //  return `http://localhost:8000${agent.pdf}`;
    };

    return (
        <div style={{ padding: "30px", background: "#020617", minHeight: "100vh", color: "white" }}>

            <h1 style={{ marginBottom: "20px" }}>❌ Rejected Agents</h1>

            <table style={{ width: "100%", borderSpacing: "0 10px", textAlign: "left" }}>
                <thead>
                    <tr style={{ color: "#64748b" }}>
                        <th style={{ padding: "10px" }}>Name</th>
                        <th style={{ padding: "10px" }}>Status</th>
                        <th style={{ padding: "10px" }}>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {agents.map((a) => (
                        <tr key={a.id} style={{ background: "#0f172a" }}>
                            <td style={{ padding: "15px" }}>{a.name}</td>

                            <td style={{ padding: "15px" }}>
                                <span style={{
                                    background: "rgba(239,68,68,0.2)",
                                    color: "#ef4444",
                                    padding: "5px 10px",
                                    borderRadius: "8px",
                                    fontSize: "0.85rem",
                                    fontWeight: "bold"
                                }}>
                                    {a.status}
                                </span>
                            </td>

                            <td style={{ padding: "15px" }}>
                                <button
                                    onClick={() => setSelectedAgent(a)}
                                    style={{
                                        background: "#3b82f6",
                                        color: "white",
                                        padding: "8px 14px",
                                        borderRadius: "8px",
                                        border: "none",
                                        cursor: "pointer",
                                        fontWeight: "600"
                                    }}
                                >
                                    👁 View Document
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* 🔥 MODAL */}
            {selectedAgent && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "#020617",
                    zIndex: 1000,
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <div style={{ 
                        padding: "20px", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                        borderBottom: "1px solid #1e293b"
                    }}>
                        <h2 style={{ margin: 0 }}>{selectedAgent.name}</h2>
                        <button 
                            onClick={() => setSelectedAgent(null)}
                            style={{
                                background: "#ef4444",
                                color: "white",
                                border: "none",
                                padding: "8px 16px",
                                borderRadius: "6px",
                                cursor: "pointer"
                            }}
                        >
                            ❌ Close
                        </button>
                    </div>

                    <iframe
                        src={getPdfUrl(selectedAgent)}
                        title="PDF Viewer"
                        style={{
                            width: "100%",
                            flexGrow: 1,
                            border: "none"
                        }}
                    />
                </div>
            )}
            
            {agents.length === 0 && (
                <p style={{ textAlign: "center", color: "#64748b", marginTop: "40px" }}>
                    No rejected agents found.
                </p>
            )}
        </div>
    );
}

export default RejectedAgentsPage;